const getLanguageNameInNativeLanguage = (locale) => {
  try {
    return new Intl.DisplayNames([`${locale}`], {type: 'language'}).of(`${locale}`);
  } catch (e) {
    return 'Unknown Language';
  }
};

const supportedLanguages = () => {
  return [
    { code: 'ar', name: `${getLanguageNameInNativeLanguage('ar')}` },
    { code: 'de', name: `${getLanguageNameInNativeLanguage('de')}` },
    { code: 'en', name: `${getLanguageNameInNativeLanguage('en')}` },
    { code: 'es', name: `${getLanguageNameInNativeLanguage('es')}` },
    { code: 'fr', name: `${getLanguageNameInNativeLanguage('fr')}` },
    { code: 'ja', name: `${getLanguageNameInNativeLanguage('ja')}` },
    { code: 'kk', name: `${getLanguageNameInNativeLanguage('kk')}` },
    { code: 'pl', name: `${getLanguageNameInNativeLanguage('pl')}` },
    { code: 'pt', name: `${getLanguageNameInNativeLanguage('pt')}` },
    { code: 'ru', name: `${getLanguageNameInNativeLanguage('ru')}` },
    { code: 'sv', name: `${getLanguageNameInNativeLanguage('sv')}` },
    { code: 'th', name: `${getLanguageNameInNativeLanguage('th')}` },
    { code: 'vi', name: `${getLanguageNameInNativeLanguage('vi')}` },
    { code: 'zh', name: `${getLanguageNameInNativeLanguage('zh')}` },
    { code: 'ko', name: `${getLanguageNameInNativeLanguage('ko')}` },
    { code: 'it', name: `${getLanguageNameInNativeLanguage('it')}` },
  ];
};

const languageCodeToNameMap = supportedLanguages().reduce((resultMap, languageObj) => {
  resultMap[languageObj.code] = languageObj.name;
  return resultMap;
}, new Map());

export function getSupportedLanguages() {
  return supportedLanguages();
}

export function getLanguageName(code) {
  if (code.includes("-")) {
    code = code.split("-")[0];
  }

  return languageCodeToNameMap[code];
}